import { EdgeLoadProPlanCatalogRepository } from '@/modules/auth/infra/repositories'
import { makeAnonEdgeHttpClient } from '@/main/factories/http'
import type { LoadProPlanCatalog } from '@/modules/auth/use-cases'

export function makeLoadProPlanCatalog(): LoadProPlanCatalog {
  return new EdgeLoadProPlanCatalogRepository(makeAnonEdgeHttpClient()).execute
}
